import type { LoaderFunctionArgs } from "react-router";
import { customAnalyticsAuthorization } from "src/configs/authorization/custom-analytics";
import { authorizationLoader } from "src/router/common-loaders";
import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		path: "",
		lazy: () =>
			import(
				"src/module--custom-analytics/pages/CustomAnalyticsLanding.page"
			).then(convertFrameworkRoute),
		loader: async ({
			params: { accountId: accountIdParam },
		}: LoaderFunctionArgs) =>
			authorizationLoader(
				{ accountIdParam },
				customAnalyticsAuthorization.customAnalytics.index,
			),
	},
	{
		path: ":id",
		lazy: () =>
			import(
				"src/module--custom-analytics/pages/CustomAnalyticsReport.page"
			).then(convertFrameworkRoute),
		loader: async ({
			params: { accountId: accountIdParam },
		}: LoaderFunctionArgs) =>
			authorizationLoader(
				{ accountIdParam },
				customAnalyticsAuthorization.customAnalytics.index,
			),
	},
];
